import React from 'react';
import { createPortal } from 'react-dom';

export type ItemGrantSummaryRow = {
  memberId: string;
  label: string;
  reason?: string;
};

type Props = {
  open: boolean;
  itemName: string;
  acquired: ItemGrantSummaryRow[];
  missed: ItemGrantSummaryRow[];
  onClose: () => void;
};

const ItemGrantSummaryModal: React.FC<Props> = ({
  open,
  itemName,
  acquired,
  missed,
  onClose,
}) => {
  if (!open) return null;

  return createPortal(
    <div className="cp-apn-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="cp-apn-modal cp-pin-item-summary-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cp-pin-item-summary-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header className="cp-apn-modal-header">
          <h2 id="cp-pin-item-summary-title">아이템 처리 요약</h2>
          <button type="button" className="cp-apn-icon-btn" onClick={onClose} aria-label="닫기">
            ×
          </button>
        </header>

        <p className="cp-pin-item-summary-item-name">{itemName || '(아이템)'}</p>

        <section className="cp-pin-item-summary-section">
          <h3>아이템 획득 멤버 ({acquired.length})</h3>
          {acquired.length === 0 ? (
            <p className="cp-pin-item-summary-empty">없음</p>
          ) : (
            <ul>
              {acquired.map((r) => (
                <li key={r.memberId}>{r.label}</li>
              ))}
            </ul>
          )}
        </section>

        <section className="cp-pin-item-summary-section">
          <h3>아이템 미획득 멤버 ({missed.length})</h3>
          {missed.length === 0 ? (
            <p className="cp-pin-item-summary-empty">없음</p>
          ) : (
            <ul>
              {missed.map((r) => (
                <li key={r.memberId}>
                  <span className="cp-pin-item-summary-name">{r.label}</span>
                  {r.reason ? (
                    <span className="cp-pin-item-summary-reason"> : {r.reason}</span>
                  ) : null}
                </li>
              ))}
            </ul>
          )}
        </section>

        <footer className="cp-apn-modal-footer">
          <button type="button" className="cp-apn-btn cp-apn-btn-primary" onClick={onClose}>
            확인
          </button>
        </footer>
      </div>
    </div>,
    document.body
  );
};

export default ItemGrantSummaryModal;
